<template>
      <div fluid fill-height>
        <v-expand-x-transition>
          <landing-toolbar />
        </v-expand-x-transition>
        <v-container style="min-width:100% !important">
          <BusinessUnits/>
        </v-container>
      </div>
</template>
    
    <script>
   import BusinessUnits from '../../components/Definiciones/UnidadesDeNegocios/BusinessUnits.vue';
    import LandingToolbar from '../../components/LandingToolbar/LandingToolbar.vue'
    export default {
      components: { BusinessUnits, LandingToolbar },
    };
    </script>
    